import { render } from "./HierarchyManagementDimensionsInfoDialog.vue?vue&type=template&id=2b729668&ts=true"
import script from "./HierarchyManagementDimensionsInfoDialog.vue?vue&type=script&lang=ts"
export * from "./HierarchyManagementDimensionsInfoDialog.vue?vue&type=script&lang=ts"

import "./HierarchyManagementDimensionsInfoDialog.vue?vue&type=style&index=0&id=2b729668&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__